import React from "react";
import AmazonSvg from "assets/svg/amazon";
import GoogleSvg from "assets/svg/google";
import MicrosoftSvg from "assets/svg/microsoft";
import YoutubeSvg from "assets/svg/youtubesvg";
import BloombergSvg from "assets/svg/bloomberg";
import SpotifySvg from "assets/svg/spotify";
import HpSvg from "assets/svg/hp";
import SapSvg from "assets/svg/sap";

// svg
import amazonSvg from "../../assets/new-icons/amazon.svg";
import googleSvg from "../../assets/new-icons/google.svg";
import microsoftSvg from "../../assets/new-icons/microsoft.svg";
import youtubeSvg from "../../assets/new-icons/youtube.svg";
import bloombergSvg from "../../assets/new-icons/bloomberg.svg";
import spotifySvg from "../../assets/new-icons/spotify.svg";
import wixSvg from "../../assets/new-icons/wix.svg";
import hsbcSvg from "../../assets/new-icons/hsbc.svg";
import mgmPng from "../../assets/new-icons/mgm.png";
import sapSvg from "../../assets/new-icons/sap.svg";
import codeSvg from "../../assets/new-icons/code.svg";
import CanonSvg from "assets/svg/Canon";

export default function AcadmicInstruction({ BackgroundCol, content, head, colorHead, secondHead, image, thirdHead, thirdColorHead }) {
  return (
    <section className={`${BackgroundCol ? BackgroundCol : "bg-darkBlue"} py-24 lg:py-32 relative`}>
      {image ? <img src="https://tomedes.gumlet.io/frontend/images/home-en/Industry_dots.webp" alt="dots" className="invisible lg:visible absolute top-0 left-0" /> : null}

      <div className="container mx-auto px-4">
        <h2 className="text-gray text-3xl md:text-[35px] text-center font-secondary font-bold  tracking-wide lg:max-w-4xl lg:mx-auto leading-[55px]">
          {head ? head : "A Translation Services Company for every"}
          <span className="text-lightBlue"> {colorHead ? colorHead : "Industry"}</span>
          <br /> <span>{secondHead ? secondHead : " "}</span>
          <span className={`${thirdColorHead ? thirdColorHead : "text-lightBlue"}`}>{thirdHead}</span>
        </h2>
        <p className="text-lightGray font-opensans text-normal text-center py-4 leading-8 px-10 lg:max-w-5xl lg:mx-auto">
          {content
            ? content
            : "95,000 clients have entrusted Tomedes with their business. These include private individuals, small to medium businesses, and the largest corporations, leading brands, national and local governments. But most importantly: we're here for you. Right now."}
        </p>

        <div className="mx-auto pt-10 text-center">
          <div className="grid grid-cols-2 lg:grid-cols-4 place-items-center lg:gap-10 gap-8 lg:max-w-5xl lg:mx-auto">
            <AmazonSvg />
            <img src={googleSvg} alt="" />
            <MicrosoftSvg />
            <YoutubeSvg />
            <BloombergSvg />
            <SpotifySvg />
            <img src={mgmPng} alt="" />
            <HpSvg />

            {/* <GoogleSvg />
            <HpSvg />
            <AmazonSvg />
            <MicrosoftSvg />
            <YoutubeSvg />
            <BloombergSvg />
            <SpotifySvg />
            <SapSvg /> */}
          </div>
          {/* {newLogos ? <div className="grid grid-cols-2 lg:grid-cols-4 place-items-center lg:gap-10 gap-8 lg:max-w-5xl lg:mx-auto">
            <AmazonSvg />
            <img src={googleSvg} alt="" />
            <MicrosoftSvg />
            <YoutubeSvg />
            <BloombergSvg />
            <SpotifySvg />
            <img src={mgmPng} alt="" />
            <HpSvg />

         
          </div> : null } */}
        </div>
      </div>
    </section>
  );
}
